import React from 'react';
import { Page, Document, Image, View, StyleSheet } from '@react-pdf/renderer';
//import InvoiceTitle from './InvoiceTitle'
//import InvoiceAddress from './InvoiceAddress'
import PlanName from './PlanName'
import InvoiceLine from './InvoiceLine'
import AgentImage from './AgentImage'
//import BillTo from './BillTo'
//import Subject from './Subject'
import BillVoucher from './BillVoucher'
//import AgentTo from './AgentTo'
//import AgentDetails from './AgentDetails'
//import GuestDetails from './GuestDetails'
//import InvoiceNo from './InvoiceNo'
//import TotalVoucher from './TotalVoucher'
import InvoiceItemsTable from './InvoiceItemsTable'
import InvoiceThankYouMsg from './InvoiceThankYouMsg'
import InvoiceEmergency from './InvoiceEmergency'
//import AgentItemsTable from './AgentItemsTable'
//import logo from './../../../../src/public/images/logo/seyLogo.png';



const styles = StyleSheet.create({
    page: {
        fontFamily: 'Helvetica',
        fontSize: 8,
        paddingTop: 30,
        paddingLeft:60,
        paddingRight:60,
        lineHeight: 1,
        flexDirection: 'column',
    }, 
    logo: {
        width: 74,
        height: 66,
         marginBottom: -70,
    },
    agentlogo: {
        width: 66,
        height: 50,
        marginRight: 0,
       //marginLeft: 200,
    },
    logoCombine: {
        display: 'flex',
        textAlign: 'center',
        justifyContent: 'space-between'
    },
    logo_footer: {
        width: 70,
        height: 40,
    },
   
    title: {
        marginTop: 20,
        fontFamily: 'Helvetica-Oblique',
        marginBottom: 0,
    }
  });
  
  const Invoice = ({invoice}) => (
     
            <Document>
                <Page size="A4" style={styles.page}>
                    <View style={styles.logoCombine}>
                    <AgentImage />
                    <BillVoucher style={styles.agentlogo} />
                    </View>
                    <InvoiceLine />
                    <PlanName  invoice={invoice} />
                    <InvoiceItemsTable invoice={invoice} />
                    {/* <PlanName  invoice={invoice} />
                    <Subject invoice={invoice}/>
                    <BillTo invoice={invoice}/>
                    <InvoiceItemsTable invoice={invoice} />
                    <TotalVoucher invoice={invoice}/> */}
                    {/* <InvoiceEmergency /> */}
                    <InvoiceEmergency />
                    <InvoiceThankYouMsg />
                    <Image style={styles.logo_footer}  src="images/logo/seyLogo.png" />
                </Page>
            </Document>
        );
  
  export default Invoice